import { Fragment, useState } from 'react';
import { useLanguage } from '../contexts/language';
import { Language, LANGUAGES } from '../types/language';
import { MenuItem, IconButton, Menu, SvgIcon, Button } from '@mui/material';
import { RiTranslate2 } from '@remixicon/react';

const LANGUAGE_TEXT_MAP = {
  [Language.EN]: 'English',
  [Language.GA]: 'Gaeilge',
};

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeMenu = () => setAnchorEl(null);
  return (
    <>
      <IconButton
        onClick={event => {
          setAnchorEl(event.currentTarget as HTMLElement);
        }}
        className="p-2 hover:bg-teal-700"
      >
        <SvgIcon className="fill-white" component={RiTranslate2} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        {LANGUAGES.map(value => (
          <MenuItem
            key={value}
            value={value}
            disabled={value === language}
            onClick={() => {
              setLanguage(value);
              closeMenu();
            }}
          >
            {LANGUAGE_TEXT_MAP[value] ?? value}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;

export const MobileLanguageSwitcher = ({
  className,
}: {
  className?: string;
}) => {
  const { language, setLanguage } = useLanguage();
  return (
    <div className={className}>
      <div className="inline-flex gap-2 items-center">
        <SvgIcon
          className="fill-iots-brand-inverted"
          component={RiTranslate2}
        />
        {LANGUAGES.map((value, index) => (
          <Fragment key={value}>
            {index > 0 && (
              <div className="h-[16px] border-l border-iots-brand-inverted" />
            )}
            <Button
              key={value}
              variant="text"
              disabled={value === language}
              sx={{
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                },
              }}
              className={`p-0 min-w-0 text-iots-brand-inverted ${value === language ? 'font-semibold' : 'font-light'}`}
              onClick={() => {
                setLanguage(value);
              }}
            >
              {LANGUAGE_TEXT_MAP[value] ?? value}
            </Button>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
